import { Close } from "@mui/icons-material";
import {
  Alert,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { CustomButton } from "src/Components/Common/Button/CustomButton";
import { DIALOG_MAX_WIDTHS } from "src/Components/Common/Modal/ModalWidth";
import useFetch from "src/Components/Common/useFetch";
import { API_ENDPOINTS } from "src/Utils/ApiConstants/ApiUrlConstants";
import { useVendorPortal } from "../VendorPortalLayout";

const VpBulkActionDisputedEntries = ({
  selectedRows,
  openBulkActionModal,
  setOpenBulkActionModal,
  setSelectedRows,
  listVendorPortalDr,
  isNonReconViewRaisedIssues,
}) => {
  const { token } = useVendorPortal();
  // New states for radio button actions
  const [selectedAction, setSelectedAction] = useState("");
  const [vendorRemarks, setVendorRemarks] = useState("");
  const [raiseIssueText, setRaiseIssueText] = useState("");

  const handleClose = () => {
    setOpenBulkActionModal(false);
    // Reset form state
    setSelectedAction("");
    setVendorRemarks("");
    setRaiseIssueText("");
  };

  const handleSubmit = () => {
    updateTakeActionDataAction();
    // Close modal after submission
    handleClose();
  };

  const updateTakeActionDataAction = async () => {
    const apiEndpoint = isNonReconViewRaisedIssues
      ? API_ENDPOINTS.BULK_UPDATE_VP_DR_ENTRIES_ACTION_NON_RECON
      : API_ENDPOINTS.BULK_UPDATE_VP_DR_ENTRIES_ACTION;
    await useFetch(apiEndpoint.url, "POST", {
      failureMessage: apiEndpoint.failureMessage,
      showSuccessToast: true,
      config: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },

      data: {
        gapId: selectedRows.map((row) => row.gapId),
        remark: vendorRemarks || "",
        markRemarkAsRead: selectedAction === "markAllRead" ? true : false,
        issueDescription: raiseIssueText || "",
      },
      thenCallBack: (_response) => {
        setSelectedRows({});
        listVendorPortalDr(token, isNonReconViewRaisedIssues);
        handleClose();
      },
      catchCallBack: () => {},
    });
  };

  return (
    <>
      <Dialog open={openBulkActionModal} maxWidth={DIALOG_MAX_WIDTHS.SM} fullWidth>
        <DialogTitle className="dialog-title">
          <div className="heading-m">Bulk Actions</div>
          <div className="vertical_center_align">
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </div>
        </DialogTitle>

        <DialogContent dividers sx={{ p: 2 }}>
          <Alert severity="info" sx={{ marginBottom: "16px" }}>
            Note: Only one of the below action can be taken at a time
          </Alert>

          <Typography variant="subtitle2" sx={{ color: "rgba(0, 0, 0, 0.6)", marginBottom: 2 }}>
            {Object.values(selectedRows)?.filter(Boolean)?.length} Tasks selected
          </Typography>

          <FormControl component="fieldset" fullWidth>
            <RadioGroup value={selectedAction} onChange={(e) => setSelectedAction(e.target.value)} sx={{ gap: "12px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <Radio
                  value="vendorRemarks"
                  checked={selectedAction === "vendorRemarks"}
                  onChange={(e) => setSelectedAction(e.target.value)}
                  sx={{ padding: "9px" }}
                />
                <TextField
                  className="update-custom-border-radius"
                  placeholder="Vendor Remarks"
                  value={vendorRemarks}
                  onChange={(e) => setVendorRemarks(e.target.value)}
                  fullWidth
                  size="small"
                  disabled={selectedAction !== "vendorRemarks"}
                />
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <Radio
                  value="raiseIssue"
                  checked={selectedAction === "raiseIssue"}
                  onChange={(e) => setSelectedAction(e.target.value)}
                  sx={{ padding: "9px" }}
                />
                <TextField
                  className="update-custom-border-radius"
                  placeholder="Raise Dispute if you are not satisfied with the resolution"
                  value={raiseIssueText}
                  onChange={(e) => setRaiseIssueText(e.target.value)}
                  fullWidth
                  size="small"
                  disabled={selectedAction !== "raiseIssue"}
                />
              </div>

              {/* <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <Radio
                  value="raiseIssue"
                  checked={selectedAction === "raiseIssue"}
                  onChange={(e) => setSelectedAction(e.target.value)}
                  sx={{ padding: "9px" }}
                />
                <TextField
                  className="update-custom-border-radius"
                  placeholder="Raise Issue"
                  value={raiseIssueText}
                  onChange={(e) => setRaiseIssueText(e.target.value)}
                  fullWidth
                  size="small"
                  disabled={selectedAction !== "raiseIssue"}
                />
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <Radio
                  value="markAllBooked"
                  checked={selectedAction === "markAllBooked"}
                  onChange={(e) => setSelectedAction(e.target.value)}
                  sx={{ padding: "9px" }}
                />
                <Typography variant="body1" sx={{ flex: 1 }}>
                  Mark all as booked
                </Typography>
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <Radio
                  value="markAllCancelled"
                  checked={selectedAction === "markAllCancelled"}
                  onChange={(e) => setSelectedAction(e.target.value)}
                  sx={{ padding: "9px" }}
                />
                <Typography variant="body1" sx={{ flex: 1 }}>
                  Mark all as cancelled
                </Typography>
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <Radio
                  value="markAllResolved"
                  checked={selectedAction === "markAllResolved"}
                  onChange={(e) => setSelectedAction(e.target.value)}
                  sx={{ padding: "9px" }}
                />
                <Typography variant="body1" sx={{ flex: 1 }}>
                  Mark all issues as resolved
                </Typography>
              </div> */}

              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <Radio
                  value="markAllRead"
                  checked={selectedAction === "markAllRead"}
                  onChange={(e) => setSelectedAction(e.target.value)}
                  sx={{ padding: "9px" }}
                />
                <Typography variant="body1" sx={{ flex: 1 }}>
                  Mark all remarks as read
                </Typography>
              </div>
            </RadioGroup>
          </FormControl>
        </DialogContent>

        <DialogActions className="dialog-actions">
          <CustomButton size="medium" colorToken="violet" variant="outlined" onClick={handleClose}>
            Cancel
          </CustomButton>
          <CustomButton size="medium" colorToken="violet" variant="contained" onClick={handleSubmit}>
            Submit
          </CustomButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default VpBulkActionDisputedEntries;
